import { getMedStatusTranslations } from "@tellescope/utils";

export const REVERSE_STATUS_TRANSLATIONS: Record<string, string> = Object.fromEntries(
  Object.entries(getMedStatusTranslations()).map(([key, value]) => [value, key])
);
